<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import datatableMixin from '@/helpers/mixins/datatableMixin';
import Datatable from '@/components/Datatable';
import SearchableSelect from '@/components/SearchableSelect';

export default {
  page: {
    title: "İş Listesi Raporu",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mixins: [datatableMixin],
  components: {
    Layout,
    PageHeader,
    Datatable,
    SearchableSelect,
  },
  data() {
    return {
      title: "İŞ LİSTESİ RAPORU",
      items: [
        { text: "ANASAYFA", href: "/" },
        { text: "İŞ LİSTESİ RAPORU", active: true },
      ],
      disableAutoLoad: true,
      endpoint: '/reports/kurulumlar',
      exportName: 'Is_Listesi',
      statsOpen: true,
      personelStats: [],
      form: {
        tur: '',
        ilce: null,
        assigned_userid: null,
        type: '',
        startdate: '',
        startdateend: '',
        usergroup: '',
      },
      ilList: [],
      personelList: [],
      columns: [
        { name: 'İş Tipi', key: 'type', orderable: false, width: 120 },
        { name: 'Kullanıcı Adı', key: 'username', orderable: true, width: 140 },
        { name: 'İsim Soyisim', key: 'fullname', orderable: false, width: 150 },
        { name: 'Randevu Tarihi', key: 'appointment_at', className: 'text-end', orderable: true, width: 150 },
        { name: 'Tamamlanma Tarihi', key: 'done_at', className: 'text-end', orderable: true, width: 200 },
        { name: 'Servisi', key: 'tariff_name', orderable: false, width: 130 },
        { name: 'İlçe', key: 'province', className: 'text-end', orderable: false, width: 120 },
        { name: 'Bölge', key: 'township', className: 'text-end', orderable: false, width: 120 },
        { name: 'Adres', key: 'address', className: 'text-end', orderable: false },
        { name: 'Kurulumu Yapan', key: 'kurulum_name', orderable: false, width: 140 },
      ],
      tableData: {
        detail: true,
        detailOpen: false,
        excel: true,
        searchable: {
          visible: false,
          placeholder: "",
        },
      },
      typeOptions: [
        { id: '', name: 'Tüm İş Türleri' },
        { id: '1', name: 'Kurulum' },
        { id: '2', name: 'Söküm' },
        { id: '3', name: 'Arıza' },
        { id: '4', name: 'Taşıma' },
      ],
      turOptions: [
        { id: '', name: 'Tüm Türler' },
        { id: 'adsl', name: 'Adsl' },
        { id: 'wifi', name: 'Wireless' },
      ],
    };
  },
  computed: {
    statsTotals() {
      return this.personelStats.reduce((acc, row) => {
        acc.kurulum += row.kurulum;
        acc.sokum += row.sokum;
        acc.ariza += row.ariza;
        acc.tasima += row.tasima;
        acc.total += row.total;
        return acc;
      }, { kurulum: 0, sokum: 0, ariza: 0, tasima: 0, total: 0 });
    },
  },
  mounted() {
    this.getUsers();
    this.ilListesi();
    this.searchParams = { ...this.form };
    this.loadPage();
  },
  methods: {
    buildPayload() {
      const columnFilters = {};
      Object.keys(this.searchParams || {}).forEach(key => {
        const val = this.searchParams[key];
        if (val !== '' && val !== null && val !== undefined) {
          columnFilters[key] = val;
        }
      });

      const payload = {
        columnFilters,
        page: this.params.page,
        perPage: this.params.per_page,
      };

      if (this.sort.column && this.sort.order && this.sort.order !== 'none') {
        payload.sort = { field: this.sort.column, type: this.sort.order };
      }

      return payload;
    },

    async loadPage() {
      this.params.page === 1 ? this.isLoading = true : this.pageLoading = true;

      try {
        const response = await this.$http.post(this.endpoint, this.buildPayload());
        this.tableData.data = response.data.data;
        this.tableData.pagination = {
          current_page: response.data.current_page,
          last_page: response.data.last_page,
          total: response.data.total,
        };
        this.personelStats = response.data.personel_stats || [];
      } finally {
        this.params.page === 1 ? this.isLoading = false : this.pageLoading = false;
      }
    },

    handleSortColumn(columnKey, sortOrder) {
      if (this.isLoading) return;
      this.sort.column = columnKey;
      this.sort.order = sortOrder;
      this.params.page = 1;
      this.loadPage();
    },

    handleFilterChange() {
      this.searchParams = { ...this.form };
      this.params.page = 1;
      this.loadPage();
    },

    clearFilter(field) {
      this.form[field] = ['assigned_userid', 'ilce'].includes(field) ? null : '';
      this.handleFilterChange();
    },

    clearDates() {
      this.form.startdate = '';
      this.form.startdateend = '';
      this.handleFilterChange();
    },

    typeBadge(row) {
      const verici = row.transmitter_id ? 'Verici ' : '';
      switch (row.type) {
        case 1: return { class: 'bg-success', text: `${verici}Kurulum` };
        case 2: return { class: 'bg-danger', text: 'Söküm' };
        case 3: return { class: 'bg-warning', text: `${verici}Arıza` };
        case 4: return { class: 'bg-info', text: 'Taşıma' };
        default: return { class: 'bg-secondary', text: '-' };
      }
    },

    getUsers() {
      this.$http.get('/technic-service/listServicePersonel')
        .then(response => {
          this.personelList = response.data.content.map(e => ({ id: e.id, name: e.name }));
        });
    },

    async ilListesi() {
      const response = await this.$http.post('/address/il/0');
      this.ilList = response.data;
    },

    appointmentFormat(now) {
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const day = now.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    today() {
      const now = new Date();
      this.form.startdate = this.appointmentFormat(now);
      this.form.startdateend = this.appointmentFormat(now);
      this.handleFilterChange();
    },

    yesterday() {
      const now = new Date();
      const yesterday = new Date(now);
      yesterday.setDate(now.getDate() - 1);
      this.form.startdate = this.appointmentFormat(yesterday);
      this.form.startdateend = this.appointmentFormat(yesterday);
      this.handleFilterChange();
    },

    week() {
      const now = new Date();
      const dayOfWeek = now.getDay();
      const startOfWeek = new Date(now);
      startOfWeek.setDate(now.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      this.form.startdate = this.appointmentFormat(startOfWeek);
      this.form.startdateend = this.appointmentFormat(endOfWeek);
      this.handleFilterChange();
    },

    month() {
      const now = new Date();
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const endOfMonth = new Date(startOfMonth.getFullYear(), startOfMonth.getMonth() + 1, 0);
      this.form.startdate = this.appointmentFormat(startOfMonth);
      this.form.startdateend = this.appointmentFormat(endOfMonth);
      this.handleFilterChange();
    },

    excelExport() {
      const currentDate = new Date();
      const filename = `${currentDate.getFullYear()}${('0' + (currentDate.getMonth() + 1)).slice(-2)}${('0' + currentDate.getDate()).slice(-2)}${('0' + currentDate.getHours()).slice(-2)}${('0' + currentDate.getMinutes()).slice(-2)}${('0' + currentDate.getSeconds()).slice(-2)}_${this.exportName}.xlsx`;

      this.$http.post(this.endpoint + '?excel=true', this.buildPayload(), { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          link.setAttribute('type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error('Excel dosyası indirilirken bir hata oluştu:', error);
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <Datatable
          :columns="columns"
          :tableData="tableData"
          tableDataLoad="pagination"
          @search-query="reLoadPage"
          @sort-column="handleSortColumn"
          @page-change="pageChange"
          @excel-export="excelExport"
          :loading="isLoading"
          :poading="pageLoading"
        >
          <template #searchItems>
            <div class="col-lg-12 mt-3">
              <div class="row">
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="d-flex justify-content-between">
                      İş Türü
                      <span
                        v-if="form.type"
                        class="text-danger"
                        style="cursor:pointer"
                        @click="clearFilter('type')"
                      >temizle</span>
                    </label>
                    <select class="form-select" v-model="form.type" @change="handleFilterChange">
                      <option v-for="(opt, i) in typeOptions" :key="i" :value="opt.id">{{ opt.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="d-flex justify-content-between">
                      Atanan Personel
                      <span
                        v-if="form.assigned_userid"
                        class="text-danger"
                        style="cursor:pointer"
                        @click="clearFilter('assigned_userid')"
                      >temizle</span>
                    </label>
                    <SearchableSelect
                      v-model="form.assigned_userid"
                      :options="personelList"
                      label="name"
                      :reduceFn="o => o.id"
                      placeholder="Personel ara..."
                      searchable
                      @input="handleFilterChange"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="d-flex justify-content-between">
                      Servis Türü
                      <span
                        v-if="form.tur"
                        class="text-danger"
                        style="cursor:pointer"
                        @click="clearFilter('tur')"
                      >temizle</span>
                    </label>
                    <select class="form-select" v-model="form.tur" @change="handleFilterChange">
                      <option v-for="(opt, i) in turOptions" :key="i" :value="opt.id">{{ opt.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label class="d-flex justify-content-between">
                      İlçe
                      <span
                        v-if="form.ilce"
                        class="text-danger"
                        style="cursor:pointer"
                        @click="clearFilter('ilce')"
                      >temizle</span>
                    </label>
                    <SearchableSelect
                      v-model="form.ilce"
                      :options="ilList"
                      label="name"
                      :reduceFn="o => o.id"
                      placeholder="İlçe ara..."
                      searchable
                      @input="handleFilterChange"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label class="d-flex justify-content-between">
                      Tarih Aralığı
                      <span
                        v-if="form.startdate || form.startdateend"
                        class="text-danger"
                        style="cursor:pointer"
                        @click="clearDates"
                      >temizle</span>
                    </label>
                    <div class="input-group">
                      <input
                        type="date"
                        class="form-control"
                        v-model="form.startdate"
                        @change="handleFilterChange"
                      >
                      <button type="button" style="border:0;background:transparent;">-</button>
                      <input
                        type="date"
                        class="form-control"
                        v-model="form.startdateend"
                        @change="handleFilterChange"
                      >
                    </div>
                    <div class="d-flex flex-wrap gap-2 mt-2">
                      <button class="btn btn-sm btn-outline-secondary" type="button" @click="today">Bugün</button>
                      <button class="btn btn-sm btn-outline-secondary" type="button" @click="yesterday">Dün</button>
                      <button class="btn btn-sm btn-outline-secondary" type="button" @click="week">Bu Hafta</button>
                      <button class="btn btn-sm btn-outline-secondary" type="button" @click="month">Bu Ay</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-12">
                  <div class="accordion">
                    <div class="accordion-item personel-stats-card">
                      <h2 class="accordion-header">
                        <button
                          type="button"
                          class="accordion-button"
                          :class="{ collapsed: !statsOpen }"
                          @click="statsOpen = !statsOpen"
                        >
                          <span class="personel-stats-title">
                            <i class="bx bx-bar-chart-alt-2 me-1"></i>
                            Personel Dağılımı
                            <span class="badge bg-primary ms-2">{{ statsTotals.total }} iş</span>
                          </span>
                        </button>
                      </h2>
                      <div class="accordion-collapse collapse" :class="{ show: statsOpen }">
                        <div class="accordion-body">
                          <div v-if="!personelStats.length" class="text-muted">
                            Seçili filtrelere göre personel verisi bulunamadı.
                          </div>
                          <div v-else class="table-responsive">
                            <table class="table table-sm align-middle mb-0 personel-stats-table">
                              <thead>
                                <tr>
                                  <th>Personel</th>
                                  <th class="text-center">Kurulum</th>
                                  <th class="text-center">Söküm</th>
                                  <th class="text-center">Arıza</th>
                                  <th class="text-center">Taşıma</th>
                                  <th class="text-center">Toplam</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(row, i) in personelStats" :key="i">
                                  <td>
                                    <strong>{{ row.name }}</strong>
                                    <div class="personel-stats-summary text-muted">
                                      <template v-if="row.kurulum">{{ row.kurulum }} kurulum</template>
                                      <template v-if="row.kurulum && (row.sokum || row.ariza || row.tasima)">, </template>
                                      <template v-if="row.sokum">{{ row.sokum }} söküm</template>
                                      <template v-if="row.sokum && (row.ariza || row.tasima)">, </template>
                                      <template v-if="row.ariza">{{ row.ariza }} arıza</template>
                                      <template v-if="row.ariza && row.tasima">, </template>
                                      <template v-if="row.tasima">{{ row.tasima }} taşıma</template>
                                      yaptı
                                    </div>
                                  </td>
                                  <td class="text-center">
                                    <span class="badge bg-success" v-if="row.kurulum">{{ row.kurulum }}</span>
                                    <span v-else class="text-muted">0</span>
                                  </td>
                                  <td class="text-center">
                                    <span class="badge bg-danger" v-if="row.sokum">{{ row.sokum }}</span>
                                    <span v-else class="text-muted">0</span>
                                  </td>
                                  <td class="text-center">
                                    <span class="badge bg-warning" v-if="row.ariza">{{ row.ariza }}</span>
                                    <span v-else class="text-muted">0</span>
                                  </td>
                                  <td class="text-center">
                                    <span class="badge bg-info" v-if="row.tasima">{{ row.tasima }}</span>
                                    <span v-else class="text-muted">0</span>
                                  </td>
                                  <td class="text-center"><strong>{{ row.total }}</strong></td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <th>Toplam</th>
                                  <th class="text-center">{{ statsTotals.kurulum }}</th>
                                  <th class="text-center">{{ statsTotals.sokum }}</th>
                                  <th class="text-center">{{ statsTotals.ariza }}</th>
                                  <th class="text-center">{{ statsTotals.tasima }}</th>
                                  <th class="text-center">{{ statsTotals.total }}</th>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template #type="{ row }">
            <span class="badge font-size-12" :class="typeBadge(row).class">{{ typeBadge(row).text }}</span>
          </template>

          <template #appointment_at="{ row }">
            {{ formatDate(row.appointment_at, 'DD.MM.YYYY HH:mm') }}
          </template>

          <template #done_at="{ row }">
            {{ formatDate(row.done_at, 'DD.MM.YYYY HH:mm') }}
          </template>

          <template #address="{ row }">
            <span v-b-popover.hover.auto="row.address">{{ row.address }}</span>
          </template>
        </Datatable>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.personel-stats-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}

.personel-stats-card .accordion-button {
  background: #fff;
  box-shadow: none !important;
  font-weight: 600;
  padding: 12px 16px;
}

.personel-stats-card .accordion-button:not(.collapsed) {
  background: #f8fafc;
  color: #1e293b;
}

.personel-stats-title {
  display: inline-flex;
  align-items: center;
  font-size: 0.95rem;
}

.personel-stats-table th {
  white-space: nowrap;
  font-size: 0.8rem;
  color: #64748b;
  border-bottom-width: 1px;
}

.personel-stats-summary {
  font-size: 0.78rem;
  margin-top: 2px;
}

.personel-stats-table tfoot th {
  border-top: 1px solid #e2e8f0;
  font-size: 0.85rem;
  color: #0f172a;
}
</style>
